import React, { useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { AssistantCommandContext } from '../components/assistant/AssistantCommandContext';
import AssistantLayout from '../components/assistant/AssistantLayout';
import AssistantChat from '../components/assistant/AssistantChat';

export default function AssistantPage() {
  const commandActionsRef = useRef(null);

  return (
    <AssistantCommandContext.Provider value={commandActionsRef}>
      <Helmet>
        <title>Assistant IA - Netikash Developer</title>
        <meta name="description" content="Conversation avec l'assistant IA Netikash pour l'API, l'authentification, les paiements et les webhooks." />
      </Helmet>

      <AssistantLayout>
        <AssistantChat compact={false} commandActionsRef={commandActionsRef} />
      </AssistantLayout>
    </AssistantCommandContext.Provider>
  );
}
